var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.1667C7.00781 13.1667 4.58268 10.7415 4.58268 7.75V2.7963C4.58268 2.36449 4.58268 2.14859 4.66076 1.98115C4.74356 1.80359 4.88627 1.66088 5.06383 1.57808C5.23127 1.5 5.44717 1.5 5.87898 1.5H14.1197C14.5515 1.5 14.7674 1.5 14.9349 1.57808C15.1124 1.66088 15.2551 1.80359 15.3379 1.98115C15.416 2.14859 15.416 2.36449 15.416 2.7963V7.75C15.416 10.7415 12.9909 13.1667 9.99935 13.1667ZM9.99935 13.1667V16.5M14.166 16.5H5.83268M18.3327 3.16667V7.33333M1.66602 3.16667V7.33333",
    stroke: "#FF7D1F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWonIcon);
export default __webpack_public_path__ + "static/media/wonIcon.12b300708faea2b56d90cfa7b299a77e.svg";
export { ForwardRef as ReactComponent };